import { render, staticRenderFns } from "./ownDonate.vue?vue&type=template&id=14c29d11&scoped=true&"
import script from "./ownDonate.vue?vue&type=script&lang=js&"
export * from "./ownDonate.vue?vue&type=script&lang=js&"
import style0 from "./ownDonate.vue?vue&type=style&index=0&id=14c29d11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c29d11",
  null
  
)

export default component.exports